// extracted by mini-css-extract-plugin
export default {"container":"ShareThoughtDrawer_container__RJ1yT","textArea":"ShareThoughtDrawer_textArea__cQmNP","hsCharCounter":"ShareThoughtDrawer_hsCharCounter__qAXG9"};